import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';
import { userGroupItem } from './fragments';

export const USER_GROUPS_QUERY = gql`
  query userGroupsConfig {
    userGroupsConfig {
      id
      code
      name
    }
  }
`;

export const PAGED_USER_GROUPS_QUERY = gql`
  query pagedUserGroupsConfig($pager: PagerInput, $filters: UserGroupFilterInput) {
    pagedUserGroupsConfig(pager: $pager, filters: $filters) {
      pagination(pager: $pager, filters: $filters) {
        ...pagination
      }
      values {
        ...userGroupItem
      }
    }
  }
  ${CommonFragments.pagination}
  ${userGroupItem}
`;
